/**
 * Local authorization list (Phase I).
 */

import { enc, ocppRequest } from './ocppApi';
import type {
  ListLocalAuthResponse,
  LocalAuthVersionResponse,
  UpdateLocalAuthBody,
  UpdateLocalAuthResponse,
} from '../models';

export const listLocalAuth = (chargerId: string) =>
  ocppRequest<ListLocalAuthResponse>({
    method: 'GET',
    path: `local-auth/${enc(chargerId)}`,
  });

export const updateLocalAuth = (chargerId: string, body: UpdateLocalAuthBody) =>
  ocppRequest<UpdateLocalAuthResponse>({
    method: 'POST',
    path: `local-auth/${enc(chargerId)}`,
    body,
  });

export const getLocalAuthVersion = (chargerId: string) =>
  ocppRequest<LocalAuthVersionResponse>({
    method: 'GET',
    path: `local-auth/${enc(chargerId)}/version`,
  });
